module.exports = __webpack_public_path__ + "img/nicola-yoon.ada7095d.png";